// extracted by mini-css-extract-plugin
export default {"accordion":"template-selector_accordion__tlGNr","icon":"template-selector_icon__wB4zP"};